import { connect } from 'react-redux';
import { setUnits, setTrailLength } from '../Actions';
import PlayerOptionsControl from '../components/playerOptions/PlayerOptionsControl';

const mapStateToProps = state => ({
  units: state.stats.labels.distance,
  trailLength: state.scene.sceneSettings.trailLength,
  isMobile: state.layout.isMobile,
});

const mapDispatchToProps = dispatch => ({
  updateUnits: unit => {
    dispatch(setUnits(unit));
    analytics.event({
      category: 'Player Settings',
      action: `Set Units To ${unit}`,
    });
  },
  setTrailLength: trailLength => {
    dispatch(setTrailLength(trailLength));
    analytics.event({
      category: 'Set Trail Length',
      action: `Set Trail Length To ${trailLength}`,
    });
  },
});

const OptionsControl = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlayerOptionsControl);

export default OptionsControl;
